import React from 'react';
import { colors } from '../../config';

const Radio = ({ id, name, label, value, checked, register, defaultChecked, ...rest }) => (
  <div>
    <input
      id={id}
      type="radio"
      name={name}
      value={value}
      checked={checked}
      ref={register}
      defaultChecked={defaultChecked}
      {...rest}
    />

    <label htmlFor={id}>{label}</label>

    <style jsx>{`
      div {
        display: block;
        margin-bottom: 16px;
        min-height: 24px;
        position: relative;
      }

      label {
        user-select: none;
        padding-left: 24px;
        cursor: pointer;
      }

      input {
        margin: 0;
        opacity: 0;
        padding: 0;
        position: absolute;
        z-index: -1;
      }

      input:focus + label {
        outline: ${colors.outline};
      }

      label:after {
        border-radius: 50%;
        content: '';
        display: block;
        height: 8px;
        left: 0;
        position: absolute;
        top: 8px;
        left: 4px;
        transition: transform 0.35s ease;
        width: 8px;
        transform: scale(0);
      }

      input:checked ~ label::after {
        background-color: ${colors.orange};
        transform: scale(1);
      }

      label:before {
        background-color: transparent;
        border-radius: 50%;
        border: 2px solid #dcdcdc;
        content: '';
        display: block;
        height: 16px;
        left: 0;
        pointer-events: none;
        position: absolute;
        top: 4px;
        user-select: none;
        width: 16px;
      }

      input:checked ~ label::before {
        border-color: ${colors.orange};
      }
    `}</style>
  </div>
);

export default Radio;
